import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useConnectionState } from './hooks';
import styles from './ConnectionNotice.module.css';

/** The socket must stay down this long before anything is shown (a normal reconnect is silent). */
const SHOW_AFTER_MS = 4_000;

/**
 * An honest, quiet notice while live updates are not running: the application keeps working and
 * re-reads what is on screen about every 30 s, but people should know why a change made by
 * somebody else is not instant. Hidden while the socket is open (or has not been needed yet).
 */
export function ConnectionNotice() {
  const { t } = useTranslation();
  const state = useConnectionState();
  const down = state === 'closed' || state === 'connecting';
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!down) return;
    const timer = setTimeout(() => {
      setVisible(true);
    }, SHOW_AFTER_MS);
    return () => {
      clearTimeout(timer);
      setVisible(false);
    };
  }, [down]);

  if (!down || !visible) return null;
  return (
    <p className={styles.notice} role="status" data-testid="connection-notice">
      {t('realtime.offline')}
    </p>
  );
}
